import i18n from '@/i18n/i18n'
import TarfinProStockInterestService from '@/services/admin/TarfinProStockInterestService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedIncludes = ['collateralType', 'maturityDay', 'campaign']
export const allowedFilters = ['tarfin_pro_campaign_id']
export const allowedSorts = 'created_at'

export const state = {
  stockInterests: [],
  stockInterest: {},
  fixedStockInterest: {}
}

export const mutations = {
  SET_STOCK_INTERESTS(state, stockInterests) {
    state.stockInterests = stockInterests.data
    state.fixedStockInterest = stockInterests.fixed_stock_interest
  },
  SET_STOCK_INTEREST(state, stockInterest) {
    state.stockInterest = stockInterest.data
  },
  ADD_STOCK_INTEREST(state, stockInterest) {
    state.stockInterests.push(stockInterest)
  }
}

export const actions = {
  getStockInterests({ commit, dispatch, state }, campaign) {
    return new Promise((resolve, reject) => {
      let query = {}

      if (campaign) {
        query = { campaign: campaign.id }
      }

      TarfinProStockInterestService.getStockInterests(query)
        .then(response => {
          commit('SET_STOCK_INTERESTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interests')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
    })
  },
  create({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.create(data)
        .then(response => {
          commit('ADD_STOCK_INTEREST', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.tarfin_pro_stock_interest.stock_interest')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interest')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  update({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.update(data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.tarfin_pro_stock_interest.stock_interests')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interests')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  findStockInterest({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.findStockInterest(data)
        .then(response => {
          commit('SET_STOCK_INTEREST', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interest')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getHistory({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.getHistory(data)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interest_history')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  saveFixedStockInterest({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.saveFixedStockInterest(data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.tarfin_pro_stock_interest.stock_interests')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.tarfin_pro_stock_interest.stock_interests')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getTypesByCampaignId({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.getTypeByCampaignId({ tarfin_pro_campaign_id: id })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_collateral_type.collateral_types')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getMaturityByTypesId({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      TarfinProStockInterestService.getMaturityByType(params)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.tarfin_pro_maturity_day.maturity_days')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
